import React from 'react';
import { FaFlask, FaMicroscope, FaProjectDiagram } from 'react-icons/fa';
import './Features.css';

export default function Features() {
  const features = [
    {
      icon: <FaFlask />,
      subtitle: "Research Focus",
      title: "Synthetic Organic Chemistry",
    },
    {
      icon: <FaMicroscope />,
      subtitle: "Core Expertise",
      title: "Drug Discovery & Anticancer Agents",
    },
    {
      icon: <FaProjectDiagram />,
      subtitle: "Advanced Materials",
      title: "Nanomaterials & Nanocomposites",
    }
  ];

  return (
    <section className="features">
      <div className="features__container">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <div className="feature-card__icon-wrapper">
              {feature.icon}
            </div>
            <div className="feature-card__content">
              <span className="feature-card__subtitle">{feature.subtitle}</span>
              <h3 className="feature-card__title">{feature.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
